import styled from "styled-components";


interface MainImage {
    image: string,
    title: string
}

export default function HomePageMainImage({ image, title }: MainImage) {
    const MainImageContainer = styled.div`
        
        position: relative;
        h1 {
            font-size: 2rem;
            font-weight: bold;
            color: whitesmoke;
            position: absolute;
            top: 20%;
            text-align: center;
            text-shadow: 2px 2px 0px #000;
        }
        img {
            
            width: 100vw;
            height: 60vh; 
            background-size: cover;
            
    }
    `;

    return (
        <>
            <MainImageContainer>
                <h1>{title}</h1>
                <img src={image} alt="Main card" />
            </MainImageContainer>
        </>
    );
}